<div  style="height: 99%;" #edad3container class="svg-container">
  <svg #svgContainer class="svg-content" [id]="id" width="100%" height="100%"></svg>
</div>